import CloseIcon from "@mui/icons-material/Close";
import { Box, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import React, { useState } from "react";
import PoolDetails from "../../PoolDetails";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paperWidthSm": {
    maxWidth: "1200px ! important",
  },
}));

export default function LocationPopup({ userId, userName }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Location" arrow>
        <IconButton onClick={handleClickOpen}>
          <LocationOnIcon color="warning" />
        </IconButton>
      </Tooltip>

      <Box>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <Box>
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              Location's
            </DialogTitle>

            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>

            <DialogContent
              dividers
              className="test-popup"
              sx={{
                minWidth: "704px !important",
              }}
            >
              <PoolDetails userId={userId} userName={userName} />
            </DialogContent>
          </Box>
        </BootstrapDialog>
      </Box>
    </>
  );
}
